<div class="flex flex-col gap-1">
  <!-- EMAIL -->
  <label for="guest-email" class="text-gray-500 text-sm font-medium leading-5 mt-2 mb-1 w-full"
    >Email <span class="text-mib-danger">*</span></label
  >
  <div class="relative w-full">
    <input
      id="guest-email"
      class="mib-input w-full"
      [class.mib-field-error]="guestForm.email().touched() && guestForm.email().invalid()"
      [formField]="guestForm.email"
      type="email"
      autocomplete="email" />
    @if (guestForm.email().touched() && guestForm.email().invalid()) {
      @for (error of guestForm.email().errors(); track error) {
        <div class="text-mib-danger text-xs mt-1">{{ error.message }}</div>
      }
    }
  </div>

  <!-- LASTNAME -->
  <label for="guest-lastname" class="text-gray-500 text-sm font-medium leading-5 mt-4 mb-1 w-full"
    >Last Name <span class="text-mib-danger">*</span></label
  >
  <div class="relative w-full">
    <input
      id="guest-lastname"
      class="mib-input w-full"
      [class.mib-field-error]="guestForm.lastname().touched() && guestForm.lastname().invalid()"
      [formField]="guestForm.lastname"
      type="text"
      autocomplete="family-name" />
    @if (guestForm.lastname().touched() && guestForm.lastname().invalid()) {
      @for (error of guestForm.lastname().errors(); track error) {
        <div class="text-mib-danger text-xs mt-1">{{ error.message }}</div>
      }
    }
  </div>

  <!-- FIRSTNAME -->
  <label for="guest-firstname" class="text-gray-500 text-sm font-medium leading-5 mt-4 mb-1 w-full"
    >First Name <span class="text-mib-danger">*</span></label
  >
  <div class="relative w-full">
    <input
      id="guest-firstname"
      class="mib-input w-full"
      [class.mib-field-error]="guestForm.firstname().touched() && guestForm.firstname().invalid()"
      [formField]="guestForm.firstname"
      type="text"
      autocomplete="given-name" />
    @if (guestForm.firstname().touched() && guestForm.firstname().invalid()) {
      @for (error of guestForm.firstname().errors(); track error) {
        <div class="text-mib-danger text-xs mt-1">{{ error.message }}</div>
      }
    }
  </div>
</div>
